<template>
  <zj-layout-container v-loading="!isInited" element-loading-text="加载中">
    <zj-layout-header>
      <div class="listtitle">事件信息</div>
      <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="事件名称">
          <el-input v-model="eventName" style="width:50rem"></el-input>
        </el-form-item>
        <el-form-item label="事件类型">
          <el-select v-model="eventType" placeholder="请选择" style="width:50rem">
            <el-option>请选择</el-option>
            <el-option
              v-for="item in EventTypeOptions"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker placeholder="选择日期" value-format="yyyy-MM-dd 00:00:00" v-model="ReportStartTime" style="width:50rem"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker placeholder="选择日期"  value-format="yyyy-MM-dd 23:59:59"  v-model="ReportEndTime" style="width:50rem"></el-date-picker>
        </el-form-item>
        <el-form-item class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
    </zj-layout-header>
    <zj-layout-main>
      <el-table
        v-loading="searching"
        element-loading-text="搜索中"
        :data="tableData"
        height="100%">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="eventName" label="事件名称"></el-table-column>
        <el-table-column prop="eventAddress" label="事发地点"></el-table-column>
        <el-table-column prop="eventLevel" label="事件等级" width="140" align="center">
          <template slot-scope="scope">
              <span>{{scope.row.status==1 ? scope.row.eventLevelTranslated : scope.row.verifyEventLevelTranslated}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="eventType" label="事件类型" width="140" align="center">
          <template slot-scope="scope">
              <span>{{ scope.row.status==1 ? scope.row.eventTypeTranslated : scope.row.verifyEventTypeTranslated}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="happenTime" label="事发时间" width="140" align="center"></el-table-column>
        <el-table-column prop="reportTime" label="上报时间" width="140" align="center"></el-table-column>
        <el-table-column prop="reportName" label="上报人" width="140" align="center"></el-table-column>
        <el-table-column prop="reportContact" label="联系方式" width="145" align="center"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.status==1">
              <el-button  @click="verify(scope.$index,scope.row)" type="text" size="small">核实</el-button>
              <el-button  @click="startUp(scope.row)" type="text" size="small" v-show="false">启动应急</el-button>
            </template>
            <el-button v-else-if="scope.row.status==2" @click="report(scope.$index,scope.row)" type="text" size="small">确认上报</el-button>
            <el-button v-else-if="scope.row.status==3" @click="startUp(scope.row)" type="text" size="small">启动应急</el-button>
            <el-button v-else-if="scope.row.status==7" @click="SeeComfirInfo(scope.$index,scope.row)" type="text" size="small">查看</el-button>
            <template v-else>
              <el-button @click="SeeInfo(scope.$index,scope.row)" type="text" size="small">查看</el-button>
              <el-button v-if="scope.row.status==5" @click="fileInfo(scope.row)" type="text" size="small">归档</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
    <el-dialog v-dialogDrag title="事件归档" :visible.sync="dialogOpts.dialogTableVisible">
      <EventFile :viewData="dialogOpts.rowData" @cancel="dialogCancel" @ok="dialogOk" @search="search"></EventFile>
    </el-dialog>
    <el-dialog v-dialogDrag title="启动应急" :visible.sync="dialogOpts.dialogPlanTableVisible">
      <EventPlan :viewData="dialogOpts.rowData" @cancel="dialogPlanCancel" @ok="dialogPlanOk" @search="search"></EventPlan>
    </el-dialog>
  </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
import { getDictionary } from "@/api/src/emergency_common";
import { list, remove } from "@/api/src/emergency_event";

import EventFile from "./EventFile.vue";
import EventPlan from "./EventPlan.vue";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjEventList",
  controller: "UI",
  action: "EventList",
  props: {
    fullPath: String,
    path: String,
    query: Object,
    hash: String,
    targetUrl: String,
    targetUri: Object,
    menu: Object
  }, 
  components: {
    EventFile,EventPlan
  },
  watch: {
    query(newV) {
      // console.log(newV.status);
      this.status = parseInt(newV.Status);
      this.clearsearch();
      this.search();
    }
  },
  data() {
    return {
      isInited: false, // 初始化中...
      EventTypeDic: [],
      EventLevelDic: [],
      EventTypeOptions: [],
      EventLevelOptions: [],
      tableData: [],
      eventName: null,
      eventType: null,
      ReportStartTime: null,
      ReportEndTime: null,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      status: 1,
      dialogOpts: {
        dialogTableVisible: false,
        dialogPlanTableVisible:false,
        rowData: null,
      },
      searching: false // 搜索中...
    };
  },

  created: function() {
    this.init();
    this.search();
  },

  methods: {

    init() {
      this.status = parseInt(this.query.Status);
      utils.waitAll([
        getDictionary('emergency_event_level'),
        getDictionary('emergency_event_type'),
      ])
      .then(r=>{
        // 事件等级
        const eventlevelconf = r[0];
        this.EventLevelOptions = eventlevelconf.data.records;

        // 事件类型
        const eventtypeconf = r[1];
        this.EventTypeOptions = eventtypeconf.data.records;
        this.isInited = true;
      })
      .catch(e=>{
        console.log(e);
      });

    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    search() {
      let searchInfo = {
        size : this.pageSize,
        current : this.currentPage,
        // eventName: this.eventName,
        // eventType: this.eventType,
        beginDate: this.ReportStartTime,
        endDate: this.ReportEndTime,
        status: this.status
      };
      // if(this.status == 1) {
        searchInfo.eventType = this.eventType
        searchInfo.eventName = this.eventName
      // } else {
      //   searchInfo.verifyEventType = this.eventType
      //   searchInfo.verifyEventName = this.eventName
      // }
      this.searching = true;
      console.log(searchInfo)
      return list(searchInfo)
        .then(r => {
          console.log(r,'list')
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
          this.searching = false;
        })
        .catch(e => {
          console.log(e);
          this.searching = false;
        });
    },
    clearsearch() {
      this.eventName = null;
      this.eventType = null;
      this.ReportStartTime = null;
      this.ReportEndTime = null;
    },
    // 点击查询按钮
    onSearch() {
      //  if(this.ReportEndTime==null&&this.ReportStartTime!=null){
      //   this.$message.error("请选择结束日期");
      //   return;
      //  }
      //  if(this.ReportStartTime==null&&this.ReportEndTime!=null){
      //   this.$message.error("请选择开始日期");
      //   return;
      //  }
      //  if (new Date(this.ReportEndTime) < new Date(this.ReportStartTime)) {
      //   this.$message.error("开始日期不能大于结束日期");
      //   return;
      // }
      if(!this.ReportStartTime&& this.ReportEndTime){
        this.$message.info("请选择开始日期");
        return;
      }
      if(this.ReportStartTime&& !this.ReportEndTime){
        this.$message.info("请选择结束日期");
        return;
      }
      if (new Date(this.ReportEndTime) < new Date(this.ReportStartTime)) {
        this.$message.info("开始日期不能大于结束日期");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //核实
    verify(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/ConfirmEvent",
        // name: 'mallList',
        query: { id: row.id }
      });
    },
    //确认
    report(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/ReportEvent",
        // name: 'mallList',
        query: { id: row.id }
      });
    },
    //启动
    startUp(row) {
       this.dialogOpts.rowData=row;
       this.dialogOpts.dialogPlanTableVisible = true;
    },
    //查看
    SeeInfo(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/SeeEventInfo",
        // name: 'mallList',
        query: { id: row.id, status: row.status }
      });
    },
    SeeComfirInfo(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/SeeEventInfo",
        // name: 'mallList',
        query: { id: row.id, status: row.status ,IsReport:false}
      });
    },
    //归档
    fileInfo(row) {
       this.dialogOpts.rowData=row;
       this.dialogOpts.dialogTableVisible = true;
    },
    dialogOk() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogCancel() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogPlanOk() {
      this.dialogOpts.dialogPlanTableVisible = false;
    },
    dialogPlanCancel() {
      this.dialogOpts.dialogPlanTableVisible = false;
    },
  }
};
</script>